<template>
    <div ref="azinput" class="form-group" :class="mb ? 'mb-1' : 'mb-0'">
        <small class="form-text text-muted text-nowrap text-truncate" v-if="label && type != 'checkbox-group' && type != 'label' && !compact"
            :class="mt ? '' : 'mt-0'">
            <template v-if="label == '.'">&nbsp;</template>
            <template v-else>
                {{ label }}
            </template>
            <a href="#" @click.prevent="speech ()" v-if="speechable">
                <i class="fas fa-microphone"></i> {{ speechOn }}
            </a>
            <slot name="button-label"></slot>            
        </small>

        <!-- AUTOCOMPLETE -->
        <span v-if="type == 'autocomplete'">

            <div class="autocomplete" @focusout="this.handleLoseFocus">

                <div :class="sizing ? 'input-group-' + sizing : ''" class="input-group">

                    <div class="input-group-prepend" v-if="validate && validMsg">
                        <span class="input-group-text alert-danger text-danger invalid" id="basic-addon1"
                            data-toggle="tooltip" data-placement="top" :title="validMsg">
                            <i class="fas fa-exclamation"></i>
                        </span>
                    </div>

                    <div class="input-group-prepend" v-else-if="icon">
                        <button type="button" class="btn" :class="'btn-' + buttonColor" v-if="buttonText" 
                            @click="$emit('clickButton')">
                            <i class="fa-fw" :class="buttonText" v-if="buttonIcon"></i>
                            <span v-else>
                                {{ buttonText }}
                            </span>
                        </button>
                        <span class="input-group-text" id="basic-addon1" v-else>
                            <i class="fa-fw" :class="icon + ( hli && value ? ' text-success' : '' )"></i>
                        </span>
                    </div>

                    <div class="input-group-prepend" v-if="selecionados && selecionados.length">
                        <button type="button" class="btn btn-outline-primary" v-for="(selec, isx) in selecionados" :key="isx"
                            @click="selecionados.splice(isx,1)">
                            {{ selec.st_sigla }}
                            <i class="fa fa-times" aria-hidden="true"></i>
                        </button>
                    </div>

                    <slot name="button-pre"></slot>

                    <input
                        ref="input"
                        :placeholder="placeholder"
                        v-shortkey.focus="shortkey ? shortkey : null"
                        type="text"
                        class="form form-control az-autocomplete"
                        :disabled="!edicao" 
                        autocomplete="none"
                        @input="onChange"
                        @focus="$emit('focus')"
                        v-model="search"
                        @keydown.down="onArrowDown"
                        @keydown.up="onArrowUp"
                        @keydown.enter="onEnter"
                        @keydown.esc="onEsc"
                        @blur="autocomplete_losefocus()"
                        :required="required"
                    />

                    <!-- Button After -->

                    <slot name="buttonposb"></slot>

                    <div class="input-group-append" v-if="iconEnd">
                        <button type="button" class="btn" :class="'btn-' + iconEnd.color" 
                            data-toggle="tooltip" data-placement="top" :title="iconEnd.tooltip"
                            @click="$emit('clickButtonEnd')">
                            <i :class="iconEnd.icon" v-if="iconEnd.icon"></i>
                            <span v-else>
                                {{ iconEnd.text }}
                            </span>
                        </button>
                    </div>

                </div>
                
                <ul id="autocomplete-results" 
                    v-show="isOpen" 
                    class="list-group"
                    :class="optionsPosition == 'center' ? 'autocomplete-results-center' : 'autocomplete-results'">
                    <li class="loading list-group-item" v-if="isLoading">
                        <div class="spinner-border spinner-border-sm" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </li>
                    <li class="loading list-group-item" v-else-if="!results || !results.length">
                        <span class="text-muted">Nenhum item encontrado.</span>
                        <span class="small text-muted ml-1" v-if="search && optionsExternal">[ENTER para incluir '{{ search }}']</span>
                    </li>
                    <template v-else>
                        <li
                            v-for="(result, i) in results"
                            :key="i"
                            @click="setResult(result)"
                            class="autocomplete-result list-group-item py-2"
                            :class="{ 'active': i === arrowCounter }"
                            :ref="'item_lista' + i"
                            :id="'item_lista' + i"
                        >
                            <span>{{ parte(result[optionsDisplay]) }}</span>

                            <template v-if="result && result.st_sigla">
                                <span class="badge badge-secondary ml-2">
                                    {{ result.st_sigla }}
                                </span>
                            </template>

                            <template v-if="result && result.st_codigo_sus && optionsParm && optionsParm.sus">
                                <span class="badge badge-secondary ml-2">
                                    {{ result.st_codigo_sus }}
                                </span>
                            </template>

                            <template v-if="result && result.id_procedimento && !result.unidade_procedimento">
                                <i class="fa-solid fa-asterisk ml-2" title="Item não relacionado a item de faturamento."></i>
                            </template>
                            
                            <template v-if="parte(result[optionsDisplay], false)">
                                <br>
                                <div class="text-nowrap text-truncate" :title="parte(result[optionsDisplay], false)">
                                    <small :class="i === arrowCounter ? '' : 'text-muted'">{{ parte(result[optionsDisplay], false) }}</small>
                                </div>
                            </template>
                        </li>
                    </template>
                </ul>

            </div>
            
        </span>

        <div class="input-group" :class="sizing ? 'input-group-' + sizing : ''" v-else>

            <div class="input-group-prepend" v-if="edicao && validate && validMsg && type != 'button-group'">
                <span class="input-group-text alert-danger text-danger invalid" id="basic-addon1"
                    data-toggle="tooltip" data-placement="top" :title="validMsg">
                    <i class="fas fa-exclamation"></i>
                </span>
            </div>

            <div class="input-group-prepend" v-else-if="icon">
                <slot name="prepend"></slot>
                <button type="button" class="btn" :class="'btn-' + buttonColor" v-if="buttonText" 
                    data-toggle="tooltip" data-placement="top" :title="buttonToolTip"
                    @click="$emit('clickButton')">
                    <i :class="buttonText" v-if="buttonIcon"></i>
                    <span v-else>
                        {{ buttonText }}
                    </span>
                </button>
                <span class="input-group-text" id="basic-addon1" :class="buttonColor ? 'text-' + buttonColor : ''"
                    data-toggle="tooltip" data-placement="top" :title="buttonToolTip" v-else-if="icon != 'prepend'">
                    <i :class="icon + ( hli && value ? ' text-success' : '' )"></i>
                </span>
            </div>

            <div class="input-group-prepend" v-if="compact && label && label != '.' && type != 'checkbox-group'">
                <span class="input-group-text" id="basic-addon1">
                    {{ label }}
                </span>
            </div>

            <slot name="button-pre"></slot>
            
            <!-- Sexo -->
            <select v-if="type == 'sexo'" class="form form-control" :value="value" @input="updateValue" v-shortkey.focus="shortkey ? shortkey : null"
                :disabled="!edicao">
                <option value="" :disabled="!placeholder">{{ placeholder ? placeholder : 'Selecione uma opção' }}</option>
                <template v-if="$store.state.user && $store.state.user.vtr">
                    <option value="M">Macho</option>
                    <option value="F">Fêmea</option>
                    <option value="I">Indefinido</option>    
                </template>
                <template v-else>
                    <option value="M">Masculino</option>
                    <option value="F">Feminino</option>
                    <option value="I">Indefinido</option>
                </template>
            </select>

            <!-- APAC -->
            <the-mask type="text" class="form form-control" v-model="conteudo"
                :disabled="!edicao" mask="############-#" v-else-if="type == 'apac' || type == 'aih'" />

            <!-- CPF -->
            <the-mask type="text" class="form form-control" v-model="conteudo"
                :disabled="!edicao" mask="###.###.###-##" v-else-if="type == 'cpf'" />
                
            <!-- CPF/CNPJ -->
            <the-mask type="text" class="form form-control" v-model="conteudo" :disabled="!edicao"
                mask="XX.XXX.XXX/XXXX-##" v-else-if="type == 'cnpj'" />

            <!-- CPF/CNPJ -->
            <the-mask type="text" class="form form-control" v-model="conteudo" :disabled="!edicao"
                :mask="['###.###.###-##', 'XX.XXX.XXX/XXXX-##']" v-else-if="type == 'cpf-cnpj'" />
            
            <!-- CNS SUS -->
            <the-mask type="text" class="form form-control" v-model="conteudo"
                :disabled="!edicao" mask="### #### #### ####" v-else-if="type == 'cns'" />

            <!-- CNS SUS -->
            <the-mask type="text" class="form form-control" v-model="conteudo"
                :disabled="!edicao" mask="#### #### #### ####" v-else-if="type == 'card'" />

            <!-- Mês/Ano -->
            <the-mask type="text" class="form form-control" v-model="conteudo"
                :disabled="!edicao" mask="##/####" v-else-if="type == 'mes_ano'" />

            <!-- Telefone -->
            <the-mask type="text" class="form form-control" v-model="conteudo"
                :placeholder="placeholder"
                :disabled="!edicao" :mask="['(##) ####-####', '(##) #####-####']"
                :required="required" v-else-if="type == 'fone'"
                autocomplete="off" />

            <!-- CEP -->
            <the-mask type="text" class="form form-control" v-model="conteudo"
                :disabled="!edicao" mask="#####-###" v-else-if="type == 'cep'" />
                    
            <!-- MASK -->
            <input type="text" class="form form-control" v-model="conteudo"
                :disabled="!edicao" v-mask="mask" :required="required"
                v-else-if="type == 'mask'">    

            <!-- MONEY -->
            <money 
                class="form form-control" 
                v-model="conteudo" 
                v-bind="money"
                ref="input"
                :disabled="!edicao" 
                v-money="money" 
                :required="required"
                v-else-if="type == 'money'"
                @keydown.native.enter="$emit('onEnter')" /> 
            
            <!--
            <input type="text" class="form" :value="value" @input="updateValue"
                :class="edicao ? 'form-control' : 'form-control-plaintext'"
                :disabled="!edicao" v-money="money" :required="required"
                v-else-if="type == 'money'">    
            -->
            
            <!-- SELECT -->
            <!-- :class="edicao ? 'form-control' : 'form-control-plaintext'" -->
            <select class="form form-control" 
                v-model="conteudo"
                :required="required"
                v-shortkey.focus="shortkey ? shortkey : null"
                v-else-if="type == 'select'"
                @keydown.enter="$emit('onEnter')"
                @change="$emit('change', conteudo)"
                :disabled="!edicao">    
                <option value="" v-if="isLoading">Carregando...</option>
                <option value="" v-else-if="placeholder != 'none'">{{ placeholder ? placeholder : 'Selecione...' }}</option>
                <template v-if="optionsList">
                    <option v-for="(opt, index) in optionsList" :key="index" :value="optionsData ? opt[optionsData] : opt">
                        {{ optionsDisplay ? opt[optionsDisplay] : opt['search']  }}
                    </option>
                </template>
                <template v-else>
                    <option v-for="(opt, index) in listaJson ? listaJson : filtrar_lista($store.state.options[optionsName ? optionsName : service])" :key="index" 
                        :value="optionsData ? opt[optionsData] : opt">
                        {{ optionsDisplay ? opt[optionsDisplay] : opt['search']  }}
                    </option>
                </template>
            </select>

            <!-- $store.state.options[optionsName ? optionsName : service] -->

            <!-- Text Area -->
            <textarea
                :placeholder="placeholder"
                v-else-if="type == 'textarea'"
                class="form form-control"
                :disabled="!edicao" 
                v-model="conteudo"
                :required="required"
                :rows="rows ? rows : 5"></textarea>

            <!-- CheckBox InLine -->
            <div class="input-group" :class="sizing ? 'input-group-' + sizing : ''" v-else-if="type == 'checkbox-group'">
                <div class="input-group-prepend">
                    <div class="input-group-text">
                        <input class="fa-fw" type="checkbox" v-model="conteudo" :disabled="!edicao" @click="$emit('click')">
                    </div>
                </div>
                <template v-if="cb_multilinha">
                    <textarea v-model="label" class="form form-control" :rows="rows ? rows : 3" disabled></textarea>
                </template>
                <template v-else>
                    <label class="form form-control d-inline-block text-nowrap text-truncate" v-if="label">{{ label }}</label>
                </template>
                <slot name="buttonposcb"></slot>
            </div>

            <!-- Botão de Rádio -->
            <div class="form-control" v-else-if="( type == 'radio-h' || type == 'radio-v' ) && compact">
                <template v-if="optionsList">
                    <span class="form-check form-check-inline mr-3" v-for="(opt, index) in optionsList" :key="index">
                        <input class="form-check-input" type="radio" :name="uuidv4" :value="optionsData ? opt[optionsData] : opt" v-model="conteudo">
                        <label class="form-check-label" for="exampleRadios1">
                            {{ optionsDisplay ? opt[optionsDisplay] : opt['search']  }}
                        </label>
                        <br v-if="type == 'radio-v'">
                    </span>
                </template>
                <template v-else>
                    <span class="form-check form-check-inline mr-3" v-for="(opt, index) in listaJson ? listaJson : filtrar_lista($store.state.options[optionsName ? optionsName : service])" :key="index">
                        <input class="form-check-input" type="radio" :name="uuidv4" :value="optionsData ? opt[optionsData] : opt" v-model="conteudo">
                        <label class="form-check-label" for="exampleRadios1">
                            {{ optionsDisplay ? opt[optionsDisplay] : opt['search']  }}
                        </label>
                        <br v-if="type == 'radio-v'">
                    </span>
                </template>
                <slot name="buttonposcb"></slot>
            </div>

            <div :class="( compact ? '' : 'input-group ' + ( sizing ? ' input-group-' + sizing : '' ) )" v-else-if="type == 'radio-h'">
                <template v-if="optionsList">
                    <div class="form-check mr-3" v-for="(opt, index) in optionsList" :key="index">
                        <input class="form-check-input" type="radio" :name="uuidv4" :value="optionsData ? opt[optionsData] : opt" v-model="conteudo">
                        <label class="form-check-label" for="exampleRadios1">
                            {{ optionsDisplay ? opt[optionsDisplay] : opt['search']  }}
                        </label>
                    </div>
                </template>
                <template v-else>
                    <div class="form-check mr-3" v-for="(opt, index) in listaJson ? listaJson : filtrar_lista($store.state.options[optionsName ? optionsName : service])" :key="index">
                        <input class="form-check-input" type="radio" :name="uuidv4" :value="optionsData ? opt[optionsData] : opt" v-model="conteudo">
                        <label class="form-check-label" for="exampleRadios1">
                            {{ optionsDisplay ? opt[optionsDisplay] : opt['search']  }}
                        </label>
                    </div>
                </template>
                <slot name="buttonposcb"></slot>
            </div>

            <div class="input-group" :class="sizing ? 'input-group-' + sizing : ''" v-else-if="type == 'radio-v'">
                <template v-if="optionsList">
                    <div class="input-group" :class="sizing ? 'input-group-' + sizing : ''" v-for="(opt, index) in optionsList" :key="index">
                        <div class="input-group-prepend">
                            <div class="input-group-text">
                                <input type="radio" :name="uuidv4" :value="optionsData ? opt[optionsData] : opt" v-model="conteudo">
                            </div>
                        </div>
                        <label class="form-control">{{ optionsDisplay ? opt[optionsDisplay] : opt['search']  }}</label>
                    </div>
                </template>
                <template v-else>
                    <div class="input-group" :class="sizing ? 'input-group-' + sizing : ''" v-for="(opt, index) in listaJson ? listaJson : filtrar_lista($store.state.options[optionsName ? optionsName : service])" :key="index">
                        <div class="input-group-prepend">
                            <div class="input-group-text">
                                <input type="radio" :name="uuidv4" :value="optionsData ? opt[optionsData] : opt" v-model="conteudo">
                            </div>
                        </div>
                        <label class="form-control">{{ optionsDisplay ? opt[optionsDisplay] : opt['search']  }}</label>
                    </div>
                </template>
                <slot name="buttonposcb"></slot>
            </div>

            <!-- Button-Group -->
            <div class="input-group d-flex flex-column" v-else-if="type == 'button-group'">
                <div class="btn-group" role="group" aria-label="Basic example">
                    <div class="input-group-prepend" v-if="validate && validMsg">
                        <span class="input-group-text alert-danger text-danger invalid" id="basic-addon1"
                            data-toggle="tooltip" data-placement="top" :title="validMsg">
                            <i class="fas fa-exclamation"></i>
                        </span>
                    </div>
                    <button type="button" class="btn" 
                        data-toggle="tooltip" data-placement="top" :title="op.tooltip"
                        :class="( op.id == conteudo ? 'btn-secondary' : 'btn-outline-secondary' ) + ( sizing == 'sm' ? ' btn-sm' : '' ) "
                        v-for="(op, iop) in optionsList" :key="iop"
                        :disabled="!edicao"
                        @click="conteudo = op.id; $emit('click');">
                        <i :class="op.search" v-if="op.icon"></i>
                        <template v-else>{{ op.search }}</template>
                    </button>

                    <slot name="buttonposbg"></slot>
                </div>
            </div>

            <!-- Button-Group -->
            <div class="input-group d-flex flex-column" v-else-if="type == 'mult-button-group'">
                <div class="btn-group" role="group" aria-label="Basic example">
                    <div class="input-group-prepend" v-if="validate && validMsg">
                        <span class="input-group-text alert-danger text-danger invalid" id="basic-addon1"
                            data-toggle="tooltip" data-placement="top" :title="validMsg">
                            <i class="fas fa-exclamation"></i>
                        </span>
                    </div>
                    <button type="button" class="btn" 
                        :class="( conteudo[op.id] ? 'btn-secondary' : 'btn-outline-secondary' ) + ( sizing == 'sm' ? ' btn-sm' : '' ) "
                        v-for="(op, iop) in optionsList" :key="iop"
                        @click="conteudo[op.id] = !conteudo[op.id]">
                        {{ op.search }}
                    </button>
                </div>
            </div>

            <!-- Label -->
            <label class="form form-control d-inline-block text-nowrap text-truncate bg-light" disabled v-else-if="type == 'label'">
                <s v-if="riscado">{{ label }}</s>
                <span v-else>{{ label }}</span>
            </label>

            <!-- Input Geral -->
            <!-- :value="value" @input="updateValue" :class="edicao ? 'form-control' : 'form-control-plaintext'" -->
            <input 
                v-shortkey.focus="shortkey ? shortkey : null"
                :min="min"
                :max="max"
                :maxlength="maxlength"
                :step="( type == 'time' || type == 'email' ) ? null : ( step ? step : 1 )"
                ref="input"
                :placeholder="placeholder"
                :type="type" 
                class="form form-control" 
                :class="( type=='checkbox' ? 'move-left ' : '' ) + outras_classes"
                :disabled="!edicao" 
                :autocomplete="type == 'password' ? 'new-password' : 'off'"
                :name="inputname ? inputname : 'teste'"
                v-model="conteudo"
                :pattern="pattern ? pattern : null"
                v-else
                :required="required"
                @change="$emit('change', conteudo)"
                @focus="$emit('focus')"
                @click="$emit('click')"
                @keydown.enter="$emit('onEnter')"
                @keydown.down="$emit('onArrowDown')"
                @keydown.up="$emit('onArrowUp')" />

            <!-- Button After -->

            <slot name="buttonposb"></slot>

            <div class="input-group-append" v-if="iconEnd">
                <button type="button" class="btn" :class="'btn-' + iconEnd.color" 
                    data-toggle="tooltip" data-placement="top" :title="iconEnd.tooltip"
                    @click="$emit('clickButtonEnd')" v-if="iconEnd.color">
                    <i :class="iconEnd.icon" v-if="iconEnd.icon"></i>
                    <span v-else>
                        {{ iconEnd.text }}
                    </span>
                </button>
                <span class="input-group-text" id="basic-addon2" v-else>
                    <i :class="iconEnd.icon" v-if="iconEnd.icon"></i>
                    <span v-else>
                        {{ iconEnd.text }}
                    </span>
                </span>
            </div>

            <div class="input-group-append" v-if="textend">
                <span class="input-group-text" id="basic-addon2">
                    <small>{{ textend }}</small>
                </span>
            </div>

            <slot name="button-pos"></slot>

        </div>

        <!-- Modal -->
        <div class="modal fade" id="speechModal" tabindex="-1" role="dialog" 
            aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="speechable">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">Ditado {{ speechOn }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body" v-if="speechOn">
                    <h3>Ditado...</h3>
                    <az-speech></az-speech>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    <button type="button" class="btn btn-primary">Atualizar</button>
                </div>
                </div>
            </div>
        </div>

    </div>

</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzSpeech from '../../util/AzSpeech.vue';
import moment from 'moment';
import {VMoney} from 'v-money';
import {Money} from 'v-money';

export default {
    
    data () { 
        return { 
            conteudo: "",
            options: [],
            teste: null,
            timeout: 0,
            canceltoken: null, 
            
            autoCompleteIsOpen: false,

            items: [],
            isOpen: false,
            results: [],
            searched: '', 
            search: '',
            isLoading: false,
            arrowCounter: -1,
            isAsync: true,

            listaJson: null,

            speechOn: false,

            searchDebounce: null, 

            validMsg: "",

            money: {
                decimal: ',',
                thousands: '.',
                prefix: '',
                suffix: '',
                precision: this.precision,
                masked: false /* doesn't work with directive */
            },

            selecionados: [], 
        }
    },

    components: { 
        AzSpeech,
        Money,
    },

    directives: {
        money: VMoney
    },

    watch: {
        precision: function (newValue) { 
            this.money.precision = parseInt(newValue);
        },

        conteudo: function (newValue) {

            if ( this.validMsg ) { 
                $('[data-toggle="tooltip"]').tooltip("dispose");
            }

            this.validMsg = "";

            if ( !newValue && newValue !== 0 && newValue !== '0' && this.required ) { 
                this.validMsg = "Obrigatório";
            }

            /*
            if ( newValue && this.type == "email" && this.$refs.input.validity && !this.$refs.input.validity.valid ) { 
                this.validMsg = "e-mail inválido.";
            }
            */

            this.validar (newValue);

            this.$emit('input', newValue);

        },

        optionsList: function (newValue) { 
            this.items = newValue;
            this.results = newValue;
        },

        validate: { 
            handler: function (newValue) {
                if ( newValue ) { 
                    this.validar (this.conteudo);
                }
            },
            immediate: true
        },

        value: {
            handler: function (newValue) {

                if ( this.type == 'date' && newValue ) { 
                    this.conteudo = newValue.substr(0, 10);    
                } else if ( this.type == 'month' && newValue ) { 
                    this.conteudo = newValue.substr(0, 7);    
                } else if ( this.type == 'money' && !newValue ) { 
                    this.conteudo = 0;
                } else { 
                    this.conteudo = newValue;
                }

                if ( !newValue ) { 

                    this.search = "";

                } else if ( this.optionsData ) { 

                    if ( !this.optionsSync ) { 

                        let self = this;
                     
                        let item = _.find(this.items, function (item) { 
                            return item[self.optionsData] == newValue;
                        });

                        if ( item && item[this.optionsDisplay] )
                            this.search = item[this.optionsDisplay];

                    }

                } else if ( newValue && newValue.search ) { 
                    this.search = newValue.search;
                }
                
            },
            immediate: true,
        },

        search: function (newValue) { 
            this.$emit('onSearch', newValue);
        },

        optionsName: function () { 
            this.loadSelect();
        },

    },

    props: { 
        shortkey: { 
            type: Array,
            default: null, 
        },
        label: { 
            type: String,
            default: null
        }, 
        placeholder: { 
            type: String,
            default: ""
        },
        icon: { 
            type: String,
            default:  ""
        },
        edicao: { 
            type: Boolean,
            default: true 
        }, 
        value: { 
            type: null
        },
        type: { 
            type: String,
            default: 'text'
        },
        mask: { 
            type: String,
            default: ''
        },
        optionsName: { 
            type: String,
            default: ""
        },
        optionsParm: { 
            type: Object
        },
        optionsMode: { 
            type: String
        },
        optionsData: { 
            type: String,
            default: ""
        },
        optionsDisplay: { 
            type: String,
            default: "search"
        },
        optionsSync: { 
            type: Boolean,
            default: true 
        },
        optionsInitial: { 
            type: String
        },
        optionsExternal: { 
            type: Boolean,
            default: false, 
        },
        optionsPosition: { 
            type: String,
            default: ""
        },
        optionsFilter: { 
            type: Object,
            default: null
        },
        service: { 
            type: String 
        },
        optionsList: { 
            type: Array
        }, 
        optionsReload: { 
            type: Boolean,
            default: false, 
        },
        optionsAddExternalOnLoseFocus: { 
            type: Boolean,
            default: false, 
        },
        required: { 
            type: Boolean,
            default: false
        },
        validate: { 
            type: Boolean,
            default: false 
        },
        rules: { 

        }, 
        buttonText: { 
            type: String,
            default: ""
        },
        buttonIcon: { 
            type: Boolean,
            default: false
        },
        buttonColor: { 
            type: String,
            default: "outline-secondary"
        },
        buttonToolTip: { 
            type: String,
            default: ""
        },
        speechable: { 
            type: Boolean,
            default: false
        },
        precision: { 
            default: 2
        },
        rows: { 
            default: 5
        },
        mb: { 
            default: true
        },
        mt: { 
            default: true
        },
        sizing: { 
            default: "",
        },
        iconEnd: { 
            type: Object,
            default: null, 
        },
        labelClass: { 
            type: String,
            default: "", 
        },
        min: { 
            default: null, 
        },
        max: { 
            default: null, 
        },
        step: { 
            default: 1, 
        },
        maxlength: { 
            default: null, 
        },
        compact: { 
            type: Boolean,
            default: false, 
        },
        optimized_ac: { 
            type: Boolean,
            default: false, 
        },
        textend: { 
            type: String,
            default: "",
        },
        procsigla: { 
            type: Boolean,
            default: false, 
        },
        // Highlight Icon quando preenchido.
        hli: { 
            type: Boolean,
            default: true, 
        },

        inputname: { 
            type: String,
            default: "", 
        }, 

        outras_classes: { 
            type: String,
            default: "", 
        }, 
        riscado: { 
            type: Boolean,
            default: false, 
        },
        pattern: { 
            type: String,
            default: null
        }, 
        is_sus: { 
            type: Boolean,
            default: false
        },
        cb_multilinha: { 
            type: Boolean,
            default: false
        },
    },

    computed: { 
        telMask: function () { 
            return '(##) ####-####';
            
        },

        uuidv4() {
            return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
                (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
            );
        },
    },

    methods: {
        filtrar_lista (lista) { 
            if ( !lista || !this.optionsFilter )
                return lista;

            return lista.filter(item => !_.find(this.optionsFilter, (valor, chave) => { 
                    if ( Array.isArray(item[chave]) ) { 
                        return !item[chave].includes(valor);
                    } 
                    
                    return item[chave] != valor;
                })
            );           
        },

        autocomplete_losefocus() { 
            if ( this.optionsAddExternalOnLoseFocus && this.optionsExternal && this.isOpen && ( !this.results || !this.results.length ) && this.search ) { 
                this.onEnter();   
            }
        },
        emitChange () { 
            this.$emit('alterado');
        },
        parte (texto, top = true) { 
            let partes = texto.split("//");
            return top ? partes[0] : ( partes.length > 0 ? partes[1] : "" );
        },
        speech() { 
            this.speechOn = true;
            //$('#speechModal').modal('show');
        },

        vercpf(cpf) {
            if (cpf.length != 11 ||
                cpf == "00000000000" ||
                cpf == "11111111111" ||
                cpf == "22222222222" ||
                cpf == "33333333333" ||
                cpf == "44444444444" ||
                cpf == "55555555555" ||
                cpf == "66666666666" ||
                cpf == "77777777777" ||
                cpf == "88888888888" ||
                cpf == "99999999999")
                return false;

            let add = 0;
            let i;

            for (i = 0; i < 9; i++)
                    add += parseInt(cpf.charAt(i)) * (10 - i);
            let rev = 11 - (add % 11);
            if (rev == 10 || rev == 11)
                rev = 0;
            if (rev != parseInt(cpf.charAt(9)))
                return false;
            add = 0;
                    for (i = 0; i < 10; i++)
                    add += parseInt(cpf.charAt(i)) * (11 - i);
            rev = 11 - (add % 11);
            if (rev == 10 || rev == 11)
                rev = 0;
            if (rev != parseInt(cpf.charAt(10)))
                return false;
            return true;
        },

        vercnpj(cnpj) {

            cnpj = String(cnpj)
                .toUpperCase()
                .replace(/[^A-Z0-9]/g, '');

            if (cnpj.length !== 14)
                return false;

            // Os 12 primeiros podem ser letras ou números.
            // Os 2 últimos devem ser dígitos.
            if (!/^[A-Z0-9]{12}\d{2}$/.test(cnpj))
                return false;

            // Rejeita documentos compostos pelo mesmo caractere
            if (/^(.)\1{13}$/.test(cnpj))
                return false;

            const base = cnpj.substring(0, 12);

            const dv1 = this.calcularDvCnpj(base);
            const dv2 = this.calcularDvCnpj(base + dv1);

            return cnpj === (base + dv1 + dv2);
        },

        valorCnpj(caractere) {

            if (/\d/.test(caractere))
                return parseInt(caractere, 10);

            // Regra do Serpro: ASCII - 48
            return caractere.charCodeAt(0) - 48;
        },

        calcularDvCnpj(valor) {

            const pesos = valor.length === 12
                ? [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
                : [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

            let soma = 0;

            for (let i = 0; i < valor.length; i++) {
                soma += this.valorCnpj(valor[i]) * pesos[i];
            }

            const resto = soma % 11;

            return resto <= 1 ? 0 : 11 - resto;
        },

        verapac (apac) { 

            if ( !apac || apac.length != 13 )
                return false;

            if ( isNaN(apac) )
                return false;

            let numero = apac.substr(0,12);
            let div    = numero / 11;
            let teste  = div - Math.round(div);

            if ( teste < 0 )
                teste = teste + 1;

            let final = Math.round(11 * teste);

            if ( final >= 10 ) 
                final = 0;

            return apac.substr(12, 1) == final;

        },

        validar (valor) { 

            if ( !valor && valor !== 0 && valor !== '0' && this.required ) { 
                this.validMsg = 'Obrigatório';
            }

            if ( valor ) { 

                switch (this.type) {
                    case 'aih':
                        if ( !this.verapac(valor) )
                            this.validMsg = "Número de AIH inválido.";
                        break;
                    case 'apac':
                        if ( !this.verapac(valor) )
                            this.validMsg = "Número de APAC inválido.";
                        break;
                    case 'cpf':
                        if ( !this.vercpf(valor) )
                            this.validMsg = "CPF inválido.";
                        break;
                    case 'cnpj':
                        if ( !this.vercnpj(valor) )
                            this.validMsg = "CNPJ inválido.";
                        break;
                    case 'cpf-cnpj':
                        if ( !( ( valor.length == 11 && this.vercpf(valor) ) || ( valor.length == 14 && this.vercnpj(valor) ) ) )
                            this.validMsg = "CPF/CNPJ inválido.";
                        break;
                    case 'cnes': 
                        if ( valor.length != 7 )
                            this.validMsg = "O CNES deve ter 7 dígitos.";
                        break;

                    case 'fone':
                        if ( valor.length < 10 )
                            this.validMsg = "Telefone inválido.";
                        break; 

                    case 'email':
                        if ( !/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(valor) ) 
                            this.validMsg = "e-mail inválido.";
                        
                        //if ( !(/(\.\w{2,3})+$/.test(valor)) || !(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(valor)) )
                        //    this.validMsg = "e-mail inválido.";
                        break; 
 
                    default:
                        break;
                }

            }

            if ( valor && this.rules && this.rules.length ) { 
                
                this.rules.forEach(element => {

                    let rule = element.split(':');

                    switch (rule[0]) {
                        case 'nasc':
                            if ( valor > moment().format('YYYY-MM-DD') || valor < '1900-01-01' ) 
                                this.validMsg = "Data de nascimento inválida.";
                            break;

                        case 'nome':
                            if ( valor && ( valor.slice(0,4) == 'CIL ' || valor.slice(0,6) == 'TESTE ' ) ) { 
                                //
                            } else { 
                                if ( valor.length < 2 )
                                    this.validMsg = "Nome muito curto.";
                                else if ( !/^[ 'a-zA-ZÀ-ÿ\-\u00f1\u00d1]*$/gi.test(valor) )
                                    this.validMsg = "Nome inválido.";
                            }
                            break;

                        case 'nomenum':
                            if ( valor.length < 2 )
                                this.validMsg = "Nome muito curto.";
                            else if ( !/^[ 'a-zA-ZÀ-ÿ0-9\-\u00f1\u00d1]*$/gi.test(valor) )
                                this.validMsg = "Nome inválido.";
                            break;

                        case 'size':
                            if ( rule.length > 1 )
                                if ( String(valor).length != rule[1] )
                                    this.validMsg = "Inválido.";
                            break;

                        case 'futuro':
                            if ( valor < moment().format('YYYY-MM-DD') ) 
                                this.validMsg = "Data tem que ser uma data futura.";
                            break;

                        case 'passado':
                            if ( valor > moment().format('YYYY-MM-DD') ) 
                                this.validMsg = "Data não pode ser uma data futura.";
                            break;

                        case 'positivo': 
                            if ( valor <= 0 ) 
                                this.validMsg = "O valor deve ser um número positivo.";
                            break;

                        case 'zero-positivo': 
                            if ( valor < 0 ) 
                                this.validMsg = "O valor deve ser um número positivo ou zero.";
                            break;
                    
                        default:
                            break;
                    }
                });

            }

            /*
            if ( !this.validMsg && this.$refs.input && !this.$refs.input.validity.valid ) { 
                // this.validMsg = "Valor inválido: " + valor;
            }
            */

        },

        updateValue(event) {
            this.$emit('before');
            this.$emit('input', event.target.value);
        },

        obj2QueryString (obj) {
            var str = [];
            for (var p in obj)
                if (obj.hasOwnProperty(p)) {
                str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                }
            return str.join("&");
        },

        async searchAutoComplete (info = null) { 

            if ( info ) 
                this.search = info;

            // let self = this;
            let rota = this.$route;
            //const CancelToken = this.axios.CancelToken;
            //const source = CancelToken.source();

            let searchFunc = () => {

                if ( this.searched + ',' == this.search ) { 
                    if ( this.selecionarPelaSigla(this.results) ) { 
                        return;
                    }
                }

                if ( this.canceltoken ) {
                    this.canceltoken.cancel('#BC#');
                } 

                let search = this.search;

                if (search.length >= 2) {

                    /*
                    if ( self.items.length > 0 && self.items.length < 100 
                        && self.searched && self.search.substr(0, self.searched.length) == self.searched ) { 

                        self.filterResults();
                        self.isLoading = false;
                        return;

                    }
                    */

                    this.isLoading = true;
                    this.isOpen = true;

                    this.canceltoken = this.axios.CancelToken.source();

                    let parms = this.optionsParm;
                    if ( !parms )
                        parms = {};

                    parms.rota = rota.path;
                    
                    this.axios.get('aql/' + this.service + '?size=100&search=' + encodeURIComponent(search) + '&' + this.obj2QueryString (parms),
                        {
                            cancelToken: this.canceltoken.token
                        })
                        .then(res => {
                            if ( search == this.search ) { 
                                this.items = res.data;
                                this.results = res.data;
                                this.isOpen = true;
                                this.arrowCounter = -1;
                                this.searched = search;

                                this.selecionarPelaSigla(this.results);
                            }
                        })
                        .finally (() => { 
                            this.isLoading = false;
                            // self.canceltoken = null;
                        });
                    
                } else { 

                    this.items = [];
                    this.isLoading = false;
                    this.isOpen = false;
                    this.searched = "";

                }

            }; 

            if (this.timeout) { 
                clearTimeout(this.timeout); 
                this.timeout = null;
            }

            this.timeout = setTimeout(() => {
                searchFunc ();
            }, 300);

        },

        /* AutoComplete Methods */

        onChange() {
            if ( this.conteudo)
                this.conteudo = null;

            this.arrowCounter = 0;

            // Otimização para lista já carregada, necessitando apenas de refinamento.
            if ( this.optimized_ac ) { 

                let reg = new RegExp('[0-9]');

                if ( this.items.length > 0 && this.items.length < 100 && !reg.test(this.search) 
                    && this.searched && this.search.slice(0, this.searched.length) == this.searched ) { 

                    this.filterResults();

                    if ( this.search )
                        this.isOpen = true;

                    return;

                } 

            }

            // Is the data given by an outside ajax request?
            if (this.optionsSync) {
                this.isLoading = true;
                this.searchAutoComplete();
            } else {
                // Let's  our flat array
                this.filterResults();
                this.isOpen = true;
            }
        },

        filterResults() {
            let base = this.items
                .filter(item => { 
                    if ( this.optionsParm && this.optionsParm.plano_id_unidade_operacao ) { 

                        if ( item.block_uos ) { 
                            if ( _.get(item, 'block_uos.' + this.optionsParm.plano_id_unidade_operacao) ) { 
                                return false;
                            }
                        }

                        if ( item.operadora && item.operadora.unidade_operadoras ) { 

                            if ( item.operadora.unidade_operadoras.find(uo => uo.id_unidade_operacao == this.optionsParm.plano_id_unidade_operacao && uo.fl_ativo === false) ) { 
                                return false;
                            }

                            if ( item.unidade_operacao_planos.find(uo => uo.id_unidade_operacao == this.optionsParm.plano_id_unidade_operacao && uo.fl_ativo === false) ) { 
                                return false;
                            }

                            if ( item.plano_pai 
                                && item.plano_pai.unidade_operacao_planos
                                && item.plano_pai.unidade_operacao_planos.find(uo => uo.id_unidade_operacao == this.optionsParm.plano_id_unidade_operacao && uo.fl_ativo === false) ) { 

                                return false;

                            }

                        }

                    }

                    return true;
                });

            //

            // console.log('OP', this.optionsParm);

            if ( this.optionsParm && this.optionsParm.id_unidade_operacao ) { 
                base = base.filter(item => !item.pacote_unidades 
                    || !item.pacote_unidades.length 
                    || item.pacote_unidades.find(pu => 
                        pu.id_unidade_operacao == this.optionsParm.id_unidade_operacao
                            && ( !pu.pacote || pu.pacote.fl_unidade_regra )
                    || !item.pacote_unidades.find(pu => 
                        pu.id_unidade_operacao == this.optionsParm.id_unidade_operacao
                            && ( !pu.pacote || !pu.pacote.fl_unidade_regra ))
                    )
                );
            }

            //

            if ( this.selecionarPelaSigla(base) ) { 
                return;
            }
            
            // first uncapitalize all the things
            this.results = base.filter((item) => {
                let base = item[this.optionsDisplay].normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase();
                let search = this.search.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase();

                let parts = search.trim().split(' ');
                let match = parts.reduce((total, item) => {
                    item = item.replace('(', '');
                    item = item.replace(')', '');
                    
                    return total + `.*${item}.*`;
                }, "" );
                let reg = new RegExp(match, 'gi');

                //return base.toLowerCase().indexOf(search.toLowerCase()) > -1;

                if ( item.st_sigla && item.st_sigla == search ) { 
                    return true;
                }

                if ( item.st_id_externo && item.st_id_externo == this.search ) { 
                    return true;
                }

                if ( item.st_codigo_sus && item.st_codigo_sus == search ) { 
                    return true;
                }

                return reg.test(base);
            });
        },

        selecionarPelaSigla(base) { 

            if ( ( !this.optionsName
                || this.optionsName.slice(0,27) == 'procedimentos.combos.agenda' 
                || this.optionsName.slice(0,20) == 'procedimentos.agenda'
                || this.optionsName == 'procedimentos.index' ) 
                && this.search && this.procsigla ) { 

                let siglas = this.search.split(',')
                    .map(sigla => sigla.trim().toUpperCase())
                    .filter(item => item);

                let lista = base.filter(item => item.st_id_externo == siglas.at(0) || item.st_sigla == siglas.at(0));

                if ( ( lista.length > 0 || ( siglas.length > 1 && this.selecionados.length > 0 ) ) && this.search.trim().slice(-1) == ',' ) { 
                    
                    if ( lista.length > 0 ) { 
                        this.selecionados.push(lista[0]);
                    }

                    this.search = siglas.length > 1 ? siglas.slice(1).join(',') + ',' : "";
                    this.results = [];
                    this.isLoading = false;
                    this.isOpen = false;

                    this.$nextTick(() => { 
                        this.isOpen = false;
                    });
                    
                    if ( this.search ) { 
                        return this.selecionarPelaSigla(base);
                    }

                    return true;

                } else { 

                    if ( lista && lista.length ) { 
                        this.results = lista;
                        return true;
                    }

                }

            }

            return false;

        },

        setResult(result) {
            if ( result ) { 
                this.search = result[this.optionsDisplay];
                this.isOpen = false;
                this.$emit('input', this.optionsData ? result[this.optionsData] : result );
                this.$emit('selecionado');
            }
        },
        onArrowDown() {
            if (this.arrowCounter < this.results.length - 1) {
                this.arrowCounter = this.arrowCounter + 1;

                let el = _.first(this.$refs['item_lista' + this.arrowCounter]);

                if ( el ) { 
                    el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                }
            }
        },
        onArrowUp() {
            if (this.arrowCounter > 0) {
                this.arrowCounter = this.arrowCounter -1;

                let el = _.first(this.$refs['item_lista' + this.arrowCounter]);
                
                if ( el ) { 
                    el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                }
            }
        },
        onEnter() {
            if ( !this.search && this.selecionados.length > 0 ) { 
                
                this.search = "";
                this.isOpen = false;
                this.$emit('input', this.selecionados);
                this.$emit('selecionado');
                this.selecionados = [];

                return;

            }

            if ( this.arrowCounter >= 0 ) {
                this.setResult (this.results[this.arrowCounter]);
            } else if ( this.optionsExternal ) {
                if ( this.results && this.results.length == 1 ) { 
                    this.setResult (this.results[0]);
                } else if ( this.results && this.results.length > 0 ) { 
                    this.$toast.add({
                        severity: "info",
                        summary: "Atenção",
                        detail: "Selecione o item desejado na lista.",
                        life: 3000
                    });
                } else { 
                    this.isOpen = false;
                    this.$emit('input', this.search );
                    this.$emit('selecionado', this.search);
                }
            }
            
            this.arrowCounter = -1;
            this.$emit('onEnter');
        },
        onEsc() { 
            this.isOpen = false;
            this.arrowCounter = -1;
        },
        handleClickOutside(evt) {
            if (!this.$el.contains(evt.target)) {
                this.isOpen = false;
                this.arrowCounter = -1;
            }
        },

        handleLoseFocus(evt) {
            if (!this.$el.contains(evt.target)) {
                if ( this.isOpen ) { 
                    this.isOpen = false;
                    this.arrowCounter = -1;
                }
            }
        },

        loadOptions (service, id, parms) {

            let name = id ? id : service;

            if ( !this.optionsReload && this.$store.state.options[name] ) { 

                let self = this;

                if ( this.$props.type == 'select' ) { 
                    if ( service == 'codigo_tabelas.index' ) { 
                        this.$forceUpdate(); 
                    }
                }
                
                return new Promise(function(resolve) {
                    resolve(self.$store.state.options[name]);
                });
                
            }

            this.isLoading = true;

            if ( this.optionsName ) { 

                if (this.optionsName.slice(0,20) == 'procedimentos.agenda' ) { 

                    service = 'procedimentos.index';
                    
                    if ( parms ) { 
                        parms = { 
                            agenda: true,
                            ...parms 
                        };
                    } else { 
                        parms = { agenda: true };
                    }

                } else if ( this.optionsName.slice(0,27) == 'procedimentos.combos.agenda' ) { 

                    service = 'procedimentos.index';

                    if ( parms ) { 
                        parms = { agenda: true, combos: true, cbhpm: true, ...parms };    
                    } else { 
                        parms = { agenda: true, combos: true, cbhpm: true };
                    }
                    
                }

            } 

            let query = { 
                q: [ 
                    { 
                        name: service, 
                        id: 'lista',
                        parms: parms, 
                        lon: this.optionsName, 
                    } 
                ]
            };

            let info_cache = this.obter_local_storage (service);

            if ( info_cache ) { 
                return Promise.resolve(info_cache);
            }

            return this.axios.post('/aql?a=' + service, query)
                .then(res => { 
                    let options = { name: name, list: res.data.lista.data };
                    this.$store.commit('setOptions', options);
                    this.$forceUpdate();

                    let cache_version = res.data.lista.cache_version;

                    if ( cache_version ) { 
                        this.salvar_local_storage (cache_version, res.data.lista.cache_model, res.data.lista.data, service);
                    }

                    return res.data.lista.data;
                })
                .finally(() => { 
                    this.isLoading = false;
                });

        },

        obter_local_storage (service) { 

            if ( this.$store.state.user && this.$store.state.user.st_tipo != 'U' ) { 
                return; 
            }

            let version = localStorage.getItem('options_cache_' + service + '_version');  

            if ( this.$store.state.user.id_usuario == 1 ) { 
                console.log('Cache check for ' + service + ' in localStorage: ' + version);
            }

            if ( version ) { 
                
                if ( version == this.$store.state.user.cache_versions[service] ) { 
                    let cache = localStorage.getItem('options_cache_' + service);

                    if ( cache ) { 
                        cache = JSON.parse(cache);

                        let options = { name: service, list: cache.data };
                        this.$store.commit('setOptions', options);
                        this.$forceUpdate();

                        this.isLoading = false;

                        if ( this.$store.state.user.id_usuario == 1 ) { 
                            console.log('Cache hit for ' + service + ' in localStorage.');
                        }

                        return cache.data;
                    }
                }

            }

            return; 
        },

        salvar_local_storage (cache_version, cache_model, data, service) { 
            if ( cache_version && cache_model && data ) { 
                let cache = { 
                    version: cache_version,
                    model: cache_model,
                    service: service, 
                    data: data
                };

                localStorage.setItem('options_cache_' + service, JSON.stringify(cache));
                localStorage.setItem('options_cache_' + service + '_version', cache_version);
            }
        },

        loadSelect () { 

            let options;

            switch (this.$props.optionsMode) {
                case 'aql':
                    this.loadOptions (this.service, this.optionsName, this.optionsParm)
                        .then(res => { 
                            this.options = res;

                            if ( !this.optionsSync ) { 

                                this.options = res;

                                if ( this.options ) { 
                                    this.isLoading = false;
                                    this.items = this.options;
                                    this.results = this.options;
                                }

                                if ( this.optionsData ) { 

                                    let item = this.items.find(item => { 
                                        return item[this.optionsData] == this.conteudo;
                                    });

                                    if ( item ) { 
                                        this.search = item.search;
                                    }

                                }

                            }

                            console.log(this.service, res); 

                            

                        })
                        .finally(() => { 
                            this.isLoading = false;
                            
                            if ( this.search && this.isOpen ) { 
                                this.filterResults();
                            }
                        });
                    break;

                case 'json':

                    this.listaJson = this.$props.optionsList;

                    options = { 
                        name: this.service,
                        list: this.$props.optionsList
                    };
                    
                    this.$store.commit('setOptions', options);
                    this.$forceUpdate ();
                    break;

                case 'esp-ativas':
                    this.loadOptions ('especialidades.index', this.optionsName, { ativadas: true })
                        .then(res => { 
                            this.options = res;
                        });    
                    break;

                default:
                    break;
            }

        },



    },

    mounted () { 

        if ( this.$props.type == 'select' ) { 
            this.loadSelect();
        }

        if ( this.type == 'autocomplete' ) { 

            if ( this.optionsMode == 'aql' ) { 

                // console.log('mounted', this.service);
                
                if ( !this.optionsSync ) { 

                    let service = this.service;
                    let parms = this.optionsParm;

                    this.isLoading = true;

                    this.loadOptions (service, this.optionsName, parms)
                        .then(res => { 

                            this.options = res;

                            if ( this.options ) { 
                                this.isLoading = false;
                                this.items = this.options;
                                this.results = this.options;
                            }

                            if ( this.optionsData ) { 

                                let item = this.items.find(item => { 
                                        return item[this.optionsData] == this.conteudo;
                                    });

                                if ( item ) { 
                                    this.search = item.search;
                                }

                            }

                        })
                        .finally(() => { 
                            this.isLoading = false;
                            
                            if ( this.search && this.isOpen ) { 
                                this.filterResults();
                            }
                        });
                           
                } else { 

                    if ( this.conteudo && typeof this.conteudo != 'object' ) { 

                        let service = this.service.split('.')[0];

                        this.axios.get('/aql/' + service + '.show?id=' + this.conteudo)
                            .then(res => { 
                                this.search = res.data.search;
                            });

                    } else if ( this.conteudo && Array.isArray(this.conteudo) ) { 

                        this.search = this.conteudo.join(', ');

                    }

                }

            } else if ( this.optionsMode == 'json' ) { 

                this.items = this.optionsList;

            }

            if ( this.optionsInitial )
                this.search = this.optionsInitial;

            document.addEventListener('click', this.handleClickOutside);      
            //document.addEventListener('focusout', this.handleLoseFocus);      

        }
    },

    destroyed() {
        if ( this.type == 'autocomplete' ) { 
            document.removeEventListener('click', this.handleClickOutside);
            //document.removeEventListener('focusout', this.handleLoseFocus);      
        }
    }

};
</script>

<style scoped>

.move-left {
    width: auto !important;
    box-shadow: none;
}

.autocomplete {
    position: relative;
  }

.autocomplete-results {
    position: absolute;
    height: 250px;
    overflow: auto;
    width: 100%;
    z-index: 1010;
  }

.autocomplete-results-center { 
    position: fixed;
    top:20%;
    left: 0%;
    padding-left: 20%;
    padding-right: 20%;
    min-width: 400px;
    width: 100%;
    text-align: center;
}

.autocomplete-results-center .list-group-item { 
    text-align: left;
}

.autocomplete-result {
    cursor: pointer;
}

.entrada {
    text-security: circle; /* IE/Safari */
    -moz-text-security: circle; /* FireFox */
    -webkit-text-security: circle; /* Chrome/Safari  */
}
</style>